import classes from './paperlessBillingEnContentView.scss';
import { getLocalizedStrings } from  "../../../../BillingAndPayment/Payment/paymentLocalizedStrings";
import ErrorMessages from "../../../common/ErrorMessages";
 
const PbEnContentView = (props) => {
    const strings = getLocalizedStrings('paperlessBillingComponent');
    return (
        <div className={'row'}>
            <div className={'col-xs-12'}>
                {props.children}
                <div className={'row '+classes.sceConfirmaDescBlockContent}>
                    <div className={'col-xs-12'}>
                        <div className={'row'}>
                            <p className={'col-xs-12 col-sm-6 '+classes.sceStatusName}>
                                {strings.enrollStatusPb}
                            </p>
                            <p className={'col-xs-12 col-sm-6'}>
                                {/* {props.confirmObj.paperlessBillingStatus} */}
                                {props.confirmObj[0].transactionOutcome ?
                                props.confirmObj[0].transactionOutcome === 'B02' ?
                                props.confirmObj[0].transactionOutcomeDescription ?

                                ErrorMessages[props.confirmObj[0].transactionOutcome+'_1'].replace(/\(xxxxx\)/, props.confirmObj[0].transactionOutcomeDescription[0].match(/\w+$/g)) :
                                ErrorMessages[props.confirmObj[0].transactionOutcome+'_2']:
                                ErrorMessages[props.confirmObj[0].transactionOutcome]?ErrorMessages[props.confirmObj[0].transactionOutcome]:ErrorMessages['default']:
                                props.confirmObj[0].paperlessBillingStatus}
                            </p>
                        </div>
                        {/* {props.confirmObj.paperlessBillingStatus === 'Success' ?  <div className={'row'}>
                            <p className={'col-xs-12 col-sm-6 '+classes.sceStatusName}>
                                {strings.nextDatePb}
                            </p>
                            <p className={'col-xs-12 col-sm-6'}>
                            {app.appUtil.formatDate(props.confirmObj.nextBillingDate ? props.confirmObj.nextBillingDate : '', 'dddd, MMMM D, YYYY')==='Invalid date'?'currently not available':app.appUtil.formatDate(props.confirmObj.nextBillingDate, 'dddd, MMMM D, YYYY')}
                            </p>
                        </div>: null} */}
                        {/* Changes as part of csrp defect #4760 */}
                        {/* {props.confirmObj.paperlessBillingStatus === 'Success' ?  <div className={'row'}>
                            <p className={'col-xs-12 col-sm-6 '+classes.sceStatusName}>
                                {strings.defaultEmail}
                            </p>
                            <p className={'col-xs-12 col-sm-6 ' + classes.sceDefaultEmail}>
                                {props.confirmObj.defaultEmail}
                            </p>
                        </div>: null} */}
                    </div>
                </div>
            </div>
        </div>
    );

};


export default PbEnContentView;
